module.exports = __webpack_public_path__ + "static/media/qr.acbd300f.svg";